"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CHECKOUT_PROCESS_FINISH = exports.CHECKOUT_PROCESS_COUPON = exports.CHECKOUT_PROCESS_ADDRESS = exports.CHECKOUT_PROCESS_ORDER = exports.CHECKOUT_PROCESS_PRODUCT_ITEM = exports.CHECKOUT_PROCESS_PRODUCT_SELECTION = void 0;
var CHECKOUT_PROCESS_PRODUCT_SELECTION = 'CHECKOUT_PROCESS_PRODUCT_SELECTION';
exports.CHECKOUT_PROCESS_PRODUCT_SELECTION = CHECKOUT_PROCESS_PRODUCT_SELECTION;
var CHECKOUT_PROCESS_PRODUCT_ITEM = 'CHECKOUT_PROCESS_PRODUCT_ITEM';
exports.CHECKOUT_PROCESS_PRODUCT_ITEM = CHECKOUT_PROCESS_PRODUCT_ITEM;
var CHECKOUT_PROCESS_ORDER = 'CHECKOUT_PROCESS_ORDER';
exports.CHECKOUT_PROCESS_ORDER = CHECKOUT_PROCESS_ORDER;
var CHECKOUT_PROCESS_ADDRESS = 'CHECKOUT_PROCESS_ADDRESS';
exports.CHECKOUT_PROCESS_ADDRESS = CHECKOUT_PROCESS_ADDRESS;
var CHECKOUT_PROCESS_COUPON = 'CHECKOUT_PROCESS_COUPON';
exports.CHECKOUT_PROCESS_COUPON = CHECKOUT_PROCESS_COUPON;
var CHECKOUT_PROCESS_FINISH = 'CHECKOUT_PROCESS_FINISH';
exports.CHECKOUT_PROCESS_FINISH = CHECKOUT_PROCESS_FINISH;
var _default = {
  CHECKOUT_PROCESS_PRODUCT_SELECTION: CHECKOUT_PROCESS_PRODUCT_SELECTION,
  CHECKOUT_PROCESS_PRODUCT_ITEM: CHECKOUT_PROCESS_PRODUCT_ITEM,
  CHECKOUT_PROCESS_ORDER: CHECKOUT_PROCESS_ORDER,
  CHECKOUT_PROCESS_ADDRESS: CHECKOUT_PROCESS_ADDRESS,
  CHECKOUT_PROCESS_COUPON: CHECKOUT_PROCESS_COUPON,
  CHECKOUT_PROCESS_FINISH: CHECKOUT_PROCESS_FINISH
};
exports["default"] = _default;
//# sourceMappingURL=constants.js.map